import React, { useEffect, useState } from "react";
import { Htag } from "common/Htag/Htag";
import { P } from "common/P/P";

import { Input } from "common/Input/Input";
import { Button } from "common/Button/Button";
import { Link, useNavigate } from "react-router-dom";
import { routeConstants } from "navigation";
import { ReactComponent as UserIcon } from "common/assets/icons/user.svg";
import { ReactComponent as Logo } from "common/assets/icons/logo.svg";
import { ReactComponent as ArrowRight } from "common/assets/icons/ArrowRight.svg";

import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "components/App/store";
import { auth } from "redux/auth/authAsyncThunks";
// import BackgroundImage from "./BackgroundImage";
import { ReactComponent as LoginSvg } from "common/assets/icons/login-svg.svg";
import axios from "axios";
import { serviceConfig } from "configs";
import logoPicture from "common/assets/images/logo.png";
import { setCookie } from "utils/cookie";

const LoginPage: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);

	const [formData, setFormData] = useState({ username: "", password: "" });
	const [showSMSInput, setShowSMSInput] = useState(false);
	const [smsCode, setSmsCode] = useState("");
	const [formError, setFormError] = useState("");

	const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value } = e.target;
		setFormData((prev) => ({ ...prev, [name]: value }));
	};

	const handleEnterPress = async (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === "Enter" && formData.username && formData.password) {
			try {
				// Authenticate user and send OTP
				const authResponse = await axios.post(
					`${serviceConfig.apiUrl}/auth/login`,
					{
						username: formData.username,
						password: formData.password,
					}
				);

				if (authResponse.status === 200) {
					// OTP sent successfully, show OTP input
					setShowSMSInput(true);
				}
			} catch (error) {
				setFormError("Incorrect username or password.");
			}
		}
	};

	const handleSMSChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setSmsCode(e.target.value);
	};

	const handleLogin = async () => {
		try {
			// If OTP input is shown, verify the OTP
			if (showSMSInput) {
				const otpResponse = await axios.post(
					`${serviceConfig.apiUrl}/check-otp`,
					{
						username: formData.username,
						otp: smsCode,
					}
				);

				if (otpResponse.status === 200) {
					// Save user data and tokens in localStorage
					localStorage.setItem("user", JSON.stringify(otpResponse.data));
					setCookie("username", otpResponse.data.user.username, 1);
					setCookie("accessToken", otpResponse.data.accessToken, 1); // Store for 1 hour, adjust as needed
					// setCookie("expirationDate", otpResponse.data.expirationDate, 1);
					navigate(routeConstants.root.route);
				}
			} else {
				// Authenticate user and send OTP
				const authResponse = await axios.post(
					`${serviceConfig.apiUrl}/auth/login`,
					{
						username: formData.username,
						password: formData.password,
					}
				);

				if (authResponse.status === 200) {
					// OTP sent successfully, show OTP input
					setShowSMSInput(true);
				}
			}
		} catch (error) {
			setFormError("Authentication failed.");
		}
	};

	const handleKeyPress = (e: React.KeyboardEvent) => {
		if (e.key === "Enter") {
			handleLogin();
		}
	};

	useEffect(() => {
		if (isLoggedIn) {
			navigate(routeConstants.root.route);
		}
	}, [isLoggedIn, navigate]);

	return (
		<div className="grid w-screen h-screen grid-cols-2 bg-[#f9fafb]">
			<div className="flex items-center justify-center">
				<div className="grid p-8 bg-white rounded-lg shadow-md minPhone:gap-4 xl:gap-6">
					<div className="grid gap-2 grid-cols-maxTwo place-items-center place-content-center">
						{serviceConfig.digidocs_template === 1 ? (
							<>
								<Logo />
								<Htag
									tag="h1"
									type="semibold"
									className="text-3xl text-mainColor"
								>
									Digidocs
								</Htag>
							</>
						) : (
							<>
								<img src={logoPicture} alt="logo" className="w-10 h-10" />
								<Htag
									tag="h1"
									type="semibold"
									className="text-3xl text-mainColor"
								>
									Innowasiýa Maglumat Merkezi
								</Htag>
							</>
						)}
					</div>
					<div className="grid">
						{/* <Htag tag="h1" type="medium">
							Hoş geldiňiz
						</Htag> */}

						<P size="t1" type="regular" className="text-grayTwo">
							Ulgama girmek üçin ulanyjy adyňyzy we açar sözüňizi giriziň
						</P>
					</div>
					<div className="grid gap-4">
						<Input
							appearance="default"
							minWidth={window.innerWidth < 1280 ? false : true}
							type="text"
							name="username"
							withlabel={true}
							label="Ulanyjy adyňyz"
							placeholder="Ulanyjy adyňyzy giriziň"
							onChange={handleInputChange}
							value={formData.username}
							rightIcon={<UserIcon />}
							disabled={showSMSInput}
						/>
						<Input
							appearance="default"
							minWidth={window.innerWidth < 1280 ? false : true}
							type="password"
							name="password"
							withlabel={true}
							label="Açar sözüňiz"
							placeholder="*****"
							onChange={handleInputChange}
							value={formData.password}
							onKeyDown={handleEnterPress}
							disabled={showSMSInput}
						/>
						{showSMSInput && (
							<div className="grid gap-2 mt-2 grid-cols-frMax place-items-center">
								<Input
									appearance="default"
									minWidth={window.innerWidth < 1280 ? false : true}
									minWidthValue="min-w-[430px]"
									type="password"
									name="smsCode"
									placeholder="SMS kod"
									onChange={handleSMSChange}
									value={smsCode}
									onKeyDown={handleKeyPress}
								/>
								<Button
									appearance="main"
									paddingX="px-[10px]"
									paddingY="py-[10px]"
									grid="grid grid-cols-1"
									icon={<ArrowRight className="w-5 h-5" />}
									disabled={smsCode.length < 3}
									onClick={handleLogin}
								/>
							</div>
						)}
					</div>
				</div>
			</div>
			<div className="grid grid-cols-1 place-content-center place-items-center">
				<LoginSvg />
			</div>
		</div>
	);
};

export default LoginPage;
